<nz-modal
  [nzWrapClassName]="'custom-consensus-modal'"
  [nzFooter]="null"
  [nzClosable]="false"
  (nzOnCancel)="handleCancel()"
  [nzVisible]="isModalOpen$ | async"
>
<ng-container *nzModalContent class="custom-consensus-modal">
  <div class="header">
    <span class="title">Custom Consensus</span>
    <va-icon (click)="handleCancel()" name="close"></va-icon>
  </div>

  <app-custom-consensus-core
    #ccCore
    [ccVars]="ccVars"
    (onSave)="handleSave($event)"
    (onCancel)="handleCancel($event)"
  >
  </app-custom-consensus-core>
</ng-container>
</nz-modal>
